import actionTypes from './actionTypes'

const userSchoolProfileActions = {

	initialize: () => ({
		type: actionTypes.USER_SCHOOL_PROFILE_INITIALIZE,
	}),

	save: (schoolId, role) => ({
		type: actionTypes.USER_SCHOOL_PROFILE_SAVE,
		schoolId,
		role,
	}),

	saveSuccess: () => ({
		type: actionTypes.USER_SCHOOL_PROFILE_SAVE_SUCCESS,
	}),

	saveFailed: serverError => ({
		type: actionTypes.USER_SCHOOL_PROFILE_SAVE_FAILED,
		serverError,
	}),
}

export default userSchoolProfileActions
